export default __webpack_public_path__ + "images/image.b8e450b9c0028c7f29e43cdab5c1d437.svg";